import React, { Component } from 'react';

class IconArrow extends Component {
  render() {
    return (
      <svg width="44" height="44" viewBox="0 0 44 44" fill="#000000" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22" cy="22" r="22"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M32.8784 20L22.0604 9.182C21.4746 8.59621 21.4746 7.64646 22.0604 7.06068C22.6462 6.47489 23.5959 6.47489 24.1817 7.06068L37.5216 20.4006C37.5269 20.4059 37.5322 20.4112 37.5374 20.4166C37.8225 20.6897 38 21.0741 38 21.5C38 22.0047 37.7507 22.4512 37.3686 22.7231L24.1817 35.91C23.5959 36.4958 22.6462 36.4958 22.0604 35.91C21.4746 35.3242 21.4746 34.3744 22.0604 33.7887L32.849 23H7.5C6.67157 23 6 22.3285 6 21.5C6 20.6716 6.67157 20 7.5 20H32.8784Z" fill="white"/>
      </svg>
    )
  }
}

export default IconArrow;